var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAnnouncementStorage } from '../../../../ui/AppClients';
import { useAnnouncementsTranslation } from '../../../../ui/hooks';
import { Form } from '@juvare/common-form-ui/Form';
import { showInfoSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { LinearProgress } from '@mui/material';
import React from 'react';
export const AnnouncementCreateOrEdit = ({ announcementData, onCreateAnnouncement, onEditAnnouncement, extendedConfig, }) => {
    const { t, ready } = useAnnouncementsTranslation();
    const announcementStorage = useAnnouncementStorage();
    const mergedConfig = React.useMemo(() => {
        const config = {
            type: 'form',
            children: [
                {
                    key: 'title',
                    type: 'form.text',
                    label: t('announcements.title'),
                    validate: {
                        required: true,
                    },
                },
                {
                    key: 'body',
                    type: 'form.richTextEditor',
                    label: t('announcements.body'),
                    editorInit: {
                        link_target_list: false,
                        toolbar: 'undo redo | ' +
                            'bold italic underline strikethrough | ' +
                            'fontfamily fontsize blocks | ' +
                            'alignleft aligncenter alignright alignjustify | ' +
                            'outdent indent |  ' +
                            'numlist bullist | ' +
                            'forecolor backcolor removeformat | ' +
                            'link',
                    },
                    validate: {
                        required: true,
                    },
                },
                {
                    key: 'active',
                    type: 'form.checkbox',
                    label: t('announcements.active'),
                    defaultValue: false,
                },
                {
                    type: 'form.dateTimeRangePicker',
                    key: 'dateRange',
                    fromDateLabel: t('announcements.date'),
                    toDateLabel: t('announcements.date'),
                    fromTimeLabel: t('announcements.time'),
                    toTimeLabel: t('announcements.time'),
                    validate: {
                        required: true,
                    },
                },
            ],
        };
        return Object.assign(Object.assign({}, config), { children: [...config.children, ...(extendedConfig || [])] });
    }, [extendedConfig, t]);
    if (!ready) {
        return React.createElement(LinearProgress, null);
    }
    return (React.createElement(Form, { "data-test": 'announcement-form', config: mergedConfig, data: (announcementData === null || announcementData === void 0 ? void 0 : announcementData.columns)
            ? Object.assign(Object.assign({}, announcementData.columns), { body: { html: announcementData.columns.body }, dateRange: { from: announcementData.columns.publishAt, to: announcementData.columns.expiredAt } }) : undefined, onSubmit: (data) => {
            return new Promise(() => __awaiter(void 0, void 0, void 0, function* () {
                if (!announcementData) {
                    return announcementStorage.post({ action: 'create', data: data }).then(() => {
                        showInfoSnackbar({ message: t('common.saved'), autoHideDuration: 2000 });
                        onCreateAnnouncement && onCreateAnnouncement();
                    });
                }
                else if (announcementData) {
                    return announcementStorage
                        .post({ action: 'partial-update', id: announcementData.id, data: data })
                        .then(() => {
                        showInfoSnackbar({ message: t('common.saved'), autoHideDuration: 2000 });
                        onEditAnnouncement && onEditAnnouncement();
                    });
                }
            }));
        } }));
};
